export var overlayDefintions = [];

overlayDefintions.push({
    'id': 'MTOpenSeaMapPoly',
    'type': 'raster',
    'source': 'MTOpenSeaMapPoly',
    'minzoom': 0,
    'maxzoom': 22
});

overlayDefintions.push({
    'id': 'MTRiskLabels',
    'type': 'symbol',
    'source': 'MTRiskLabels',
    'layout': {
        'icon-image': 'square',
        'icon-text-fit': 'both',
        'icon-text-fit-padding': [2, 5, 2, 5],
        'text-size': 10,
        'text-field': ['get', 'description'],
        'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
        'text-radial-offset': 2,
        'text-justify': 'auto'
    },
    'paint': {
        'text-color': "#ffffff",
        'text-halo-width': 0.5,
        'icon-color': '#000000',
    }
});

overlayDefintions.push({
    'id': 'MTportsIcon',
    'type': 'symbol',
    'source': {
        'type': 'vector',
        'tiles': ['https://tileserver.maritrace.com/xyz/ports/?z={z}&x={x}&y={y}']
    },
    'source-layer': 'ports',
    'layout': {
        'icon-image': 'harbor-15',
        'icon-allow-overlap': true
    }
});

overlayDefintions.push({
    'id': 'MTportsLabel',
    'type': 'symbol',
    'source': {
        'type': 'vector',
        'tiles': ['https://tileserver.maritrace.com/xyz/ports/?z={z}&x={x}&y={y}']
    },
    'source-layer': 'ports',
    'layout': {
        'text-field': ['get', 'name'],
        'text-variable-anchor': ['bottom-right', 'bottom', 'bottom-left', 'left', 'top-left', 'top', 'top-right', 'right', 'center'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 14,
        'text-padding': 10
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTinternalWatersLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.2z2ajsr9'
    },
    'source-layer': 'eez_internal_waters_v3gpkg',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTinternalWatersPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.2z2ajsr9'
    },
    'source-layer': 'eez_internal_waters_v3gpkg',
    'paint':
    {
        'fill-color': "#e55934",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTinternalWatersLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.2z2ajsr9'
    },
    'source-layer': 'eez_internal_waters_v3gpkg',
    'layout': {
        'text-field': ['get', 'GEONAME'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTterritorialSeasLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.7m1svxir'
    },
    'source-layer': 'eez_12nm_v3gpkg',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTterritorialSeasPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.7m1svxir'
    },
    'source-layer': 'eez_12nm_v3gpkg',
    'paint':
    {
        'fill-color': "#9bc53d",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTterritorialSeasLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.7m1svxir'
    },
    'source-layer': 'eez_12nm_v3gpkg',
    'layout': {
        'text-field': ['get', 'GEONAME'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTcontiguousZonesLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.20fi2r9k'
    },
    'source-layer': 'eez_24nm_v3shp',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTcontiguousZonesPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.20fi2r9k'
    },
    'source-layer': 'eez_24nm_v3shp',
    'paint':
    {
        'fill-color': "#fde74c",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTcontiguousZonesLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.20fi2r9k'
    },
    'source-layer': 'eez_24nm_v3shp',
    'layout': {
        'text-field': ['get', 'GEONAME'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTeezsLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.34kyh11l'
    },
    'source-layer': 'eez_v11shp',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTeezsPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.34kyh11l'
    },
    'source-layer': 'eez_v11shp',
    'paint':
    {
        'fill-color': "#5bc0eb",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTeezsLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.34kyh11l'
    },
    'source-layer': 'eez_v11shp',
    'layout': {
        'text-field': ['get', 'GEONAME'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTarchipelagicWatersLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.dwhc0lrv'
    },
    'source-layer': 'eez_archipelagic_waters_v3shp',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTarchipelagicWatersPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.dwhc0lrv'
    },
    'source-layer': 'eez_archipelagic_waters_v3shp',
    'paint':
    {
        'fill-color': "#faf71e",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTarchipelagicWatersLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.dwhc0lrv'
    },
    'source-layer': 'eez_archipelagic_waters_v3shp',
    'layout': {
        'text-field': ['get', 'GEONAME'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MToceansSeasLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.6ona8yv7'
    },
    'source-layer': 'World_Seas_IHO_v3shp',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MToceansSeasPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.6ona8yv7'
    },
    'source-layer': 'World_Seas_IHO_v3shp',
    'paint':
    {
        'fill-color': "#007db3",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MToceansSeasLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.6ona8yv7'
    },
    'source-layer': 'World_Seas_IHO_v3shp',
    'layout': {
        'text-field': ['get', 'NAME'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolOilLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.0dyybw23'
    },
    'source-layer': 'Annex_Ikmz',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolOilPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.0dyybw23'
    },
    'source-layer': 'Annex_Ikmz',
    'paint':
    {
        'fill-color': "#FD5C09",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTmarpolOilLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.0dyybw23'
    },
    'source-layer': 'Annex_Ikmz',
    'layout': {
        'text-field': "MARPOL Annex I",
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolNoxiousLiquidLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.72wprtgd'
    },
    'source-layer': 'Annex_IIkmz',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolNoxiousLiquidPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.72wprtgd'
    },
    'source-layer': 'Annex_IIkmz',
    'paint':
    {
        'fill-color': "#F9C33F",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTmarpolNoxiousLiquidLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.72wprtgd'
    },
    'source-layer': 'Annex_IIkmz',
    'layout': {
        'text-field': "MARPOL Annex II",
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolSewageLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.doszja3r'
    },
    'source-layer': 'Annex_IVkmz',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolSewagePoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.doszja3r'
    },
    'source-layer': 'Annex_IVkmz',
    'paint':
    {
        'fill-color': "#977540",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTmarpolSewageLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.doszja3r'
    },
    'source-layer': 'Annex_IVkmz',
    'layout': {
        'text-field': "MARPOL Annex IV",
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolGarbageLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.4pme1ivx'
    },
    'source-layer': 'Annex_Vkmz',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolGarbagePoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.4pme1ivx'
    },
    'source-layer': 'Annex_Vkmz',
    'paint':
    {
        'fill-color': "#369C60",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTmarpolGarbageLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.4pme1ivx'
    },
    'source-layer': 'Annex_Vkmz',
    'layout': {
        'text-field': "MARPOL Annex V",
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolEcasLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.9jr84ln0'
    },
    'source-layer': 'Annex_VIkmz',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTmarpolEcasPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.9jr84ln0'
    },
    'source-layer': 'Annex_VIkmz',
    'paint':
    {
        'fill-color': "#07CABC",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTmarpolEcasLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.9jr84ln0'
    },
    'source-layer': 'Annex_VIkmz',
    'layout': {
        'text-field': "MARPOL Annex VI",
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MThrasLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.db5emevg'
    },
    'source-layer': 'Indian_Ocean_HRA',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MThrasPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.db5emevg'
    },
    'source-layer': 'Indian_Ocean_HRA',
    'paint':
    {
        'fill-color': "#e55934",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MThrasLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.db5emevg'
    },
    'source-layer': 'Indian_Ocean_HRA',
    'layout': {
        'text-field': "HRA",
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTvrasLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.10foqikz'
    },
    'source-layer': 'VRASkml',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTvrasPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.10foqikz'
    },
    'source-layer': 'VRASkml',
    'paint':
    {
        'fill-color': "#e55934",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTvrasLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.10foqikz'
    },
    'source-layer': 'VRASkml',
    'layout': {
        'text-field': "VRA",
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTimmaLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.3a9lkjzy'
    },
    'source-layer': 'iucn-imma-cjzpgi',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTimmaPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.3a9lkjzy'
    },
    'source-layer': 'iucn-imma-cjzpgi',
    'paint':
    {
        'fill-color': "#ff7b00",
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.5
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTimmaLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.3a9lkjzy'
    },
    'source-layer': 'iucn-imma-cjzpgi',
    'layout': {
        'text-field': ["to-string", ["get", "Title"]],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTjwcsLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.d32agmk3'
    },
    'source-layer': 'JWC_Zones_031',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': [
            "match",
            ["get", "Name"],
            ["IRTC East"],
            "hsl(360, 100%, 50%)",
            ["IRTC West"],
            "#00ff00",
            "#ff00ff"
        ],
        'line-width': 1
    }
});

overlayDefintions.push({
    'id': 'MTjwcsPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.d32agmk3'
    },
    'source-layer': 'JWC_Zones_031',
    'paint':
    {
        'fill-color':
            [
                "match",
                ["get", "Name"],
                ["IRTC East"],
                "hsl(360, 100%, 50%)",
                ["IRTC West"],
                "#00ff00",
                "#ff00ff"
            ]
        ,
        'fill-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            2,
            0.2
        ],
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTjwcsLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.d32agmk3'
    },
    'source-layer': 'JWC_Zones_031',
    'layout': {
        'text-field': ["to-string", ["get", "Name"]],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});



overlayDefintions.push({
    'id': 'MTtimezonesLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.8lb8jnph'
    },
    'source-layer': 'Layer_0',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTtimezonesPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.8lb8jnph'
    },
    'source-layer': 'Layer_0',
    'paint':
    {
        'fill-color': [
            "match",
            ["get", "Name"],
            ["UTC +00:00"],
            "hsl(60, 100%, 50%)",
            [
                "UTC -01:00",
                "UTC +01:00"
            ],
            "hsl(60, 100%, 46%)",
            [
                "UTC -02:00",
                "UTC +02:00"
            ],
            "hsl(60, 100%, 42%)",
            [
                "UTC -03:30",
                "UTC +03:30",
                "UTC -03:00",
                "UTC +03:00"
            ],
            "hsl(60, 100%, 38%)",
            [
                "UTC +04:30",
                "UTC -04:00",
                "UTC +04:00"
            ],
            "hsl(60, 100%, 34%)",
            [
                "UTC +05:30",
                "UTC -05:00",
                "UTC +05:00",
                "UTC +05:45"
            ],
            "hsl(60, 100%, 30%)",
            [
                "UTC +06:30",
                "UTC -06:00",
                "UTC +06:00"
            ],
            "hsl(60, 100%, 26%)",
            [
                "UTC -07:00",
                "UTC +07:00"
            ],
            "hsl(60, 100%, 23%)",
            [
                "UTC -08:00",
                "UTC +08:00",
                "UTC -08:30"
            ],
            "hsl(60, 100%, 19%)",
            [
                "UTC -09:00",
                "UTC +09:00",
                "UTC -09:30",
                "UTC +09:30"
            ],
            "hsl(60, 100%, 15%)",
            [
                "UTC +10:30",
                "UTC -10:00",
                "UTC +10:00"
            ],
            "hsl(60, 100%, 11%)",
            [
                "UTC +11:30",
                "UTC -11:00",
                "UTC +11:00"
            ],
            "hsl(60, 100%, 7%)",
            "hsl(60, 100%, 3%)"
        ],
        'fill-opacity': 0.25,
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTtimezonesLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.8lb8jnph'
    },
    'source-layer': 'Layer_0',
    'layout': {
        'text-field': ['get', 'Name'],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTgoginLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.bn95fkjv'
    },
    'source-layer': 'architecture_de_yaound_-7v9jo2',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTgoginPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.bn95fkjv'
    },
    'source-layer': 'architecture_de_yaound_-7v9jo2',
    'paint':
    {
        'fill-color': [
            "match",
            ["get", "name"],
            [
                "G",
                "F",
                "E",
                "CEDEAO/ECOWAS"
            ],
            "hsl(47, 100%, 50%)",
            "hsl(300, 100%, 39%)"
        ],
        'fill-opacity': 0.25,
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTgoginLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.bn95fkjv'
    },
    'source-layer': 'architecture_de_yaound_-7v9jo2',
    'layout': {
        'text-field': [
            "to-string",
            [
                "concat",
                "GoGIN - ",
                ["get", "name"]
            ]
        ],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTibfLine',
    'type': 'line',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.3pj6lkwl'
    },
    'source-layer': 'IBF_List-2bgr3h',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint':
    {
        'line-color': "#666666",
        'line-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            22,
            2
        ],
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            0,
            3,
            0.75
        ]
    }
});

overlayDefintions.push({
    'id': 'MTibfPoly',
    'type': 'fill',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.3pj6lkwl'
    },
    'source-layer': 'IBF_List-2bgr3h',
    'paint':
    {
        'fill-color': "#c70000",
        'fill-opacity': 0.25,
        'fill-outline-color': "#666666",
        'fill-antialias': true
    }
});

overlayDefintions.push({
    'id': 'MTibfLabel',
    'type': 'symbol',
    'source': {
        type: 'vector',
        url: 'mapbox://maridata.3pj6lkwl'
    },
    'source-layer': 'IBF_List-2bgr3h',
    'layout': {
        'text-field': [
            "to-string",
            [
                "concat",
                "",
                ["get", "name"]
            ]
        ],
        'text-radial-offset': 0.5,
        'text-justify': 'auto',
        'text-size': 11,
        'text-font': [
            "Roboto Medium",
            "Arial Unicode MS Regular"
        ]
    },
    'paint':
    {
        'text-color': '#222222',
        'text-halo-color': "#ffffff",
        'text-halo-width': 1,
        'text-halo-blur': 0,
        'text-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            3,
            0,
            4,
            1
        ]
    }
});







overlayDefintions.push({
    'id': 'MTallVesselsProjection',
    'type': 'line',
    'source': 'MTallVesselsProjection',
    'paint':
    {
        'line-blur': 1,
        'line-color': '#333333',
        'line-dasharray': [3, 1],
        'line-width': 2,
        'line-opacity': [
            "interpolate",
            ["linear"],
            ["zoom"],
            6,
            0,
            8,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTallVesselsArrow',
    'type': 'symbol',
    'source': 'mtallvessels',
    'source-layer': "mtallvessels",
    'minzoom': 6,
    'layout': {
        'icon-image': 'vessel',
        'icon-size':
            [
                "interpolate",
                ["linear"],
                ["zoom"],
                3,
                [
                    "match",
                    ["get", "uv"],
                    [1],
                    0.75,
                    0.5
                ],
                4,
                [
                    "match",
                    ["get", "uv"],
                    [1],
                    1,
                    0.75
                ]
            ],
        'icon-allow-overlap': true,
        'icon-rotate': ["get", "th"],
        'icon-pitch-alignment': "map",
        'icon-rotation-alignment': "map"
    },
    paint: {
        'icon-halo-blur': [
            "interpolate",
            ["linear"],
            ["zoom"],
            6,
            0.0,
            8,
            0.5
        ],
        'icon-halo-color': [
            "match",
            ["get", "uv"],
            [1],
            '#FFFF00',
            '#000000'
        ],
        'icon-halo-width': 3,
        'icon-color': ["match",
            ["get", "at"],
            [54], "#7e7e00",
            [71, 70, 72, 73, 74, 75, 76, 77, 78, 79], "#00007e",
            [33], "#7E007E",
            [34], "#7e0000",
            [35], "#FFFF00",
            [30], "#00ff00",
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49], "#7e7e7e",
            [55], "#007eff",
            [56, 57], "#00ff7e",
            [58], "#7e00ff",
            [59], "#7eff00",
            [90, 91, 92, 93, 94, 95, 96, 97, 98, 99], "#007e7e",
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69], "#00ffff",
            [50], "#ff007e",
            [37], "#00003e",
            [53], "#0000ff",
            [36], "#ff00ff",
            [51], "#ff7e7e",
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89], "#ff0000",
            [31], "#ffff7e",
            [32], "#ff2000",
            [52], "#ff7e00",
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29], "#003e00",
            "#dddddd"],
        "icon-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            6,
            0,
            8,
            [
                "case",
                ["<", ["get", "sp"], 1],
                0,
                [">", ["get", "th"], 360],
                0,
                1
            ],
            13,
            [
                "case",
                ["<", ["get", "sp"], 1],
                0,
                [">", ["get", "th"], 360],
                0,
                1
            ],
            14,
            [
                "match",
                ["get", "dv"],
                [1],
                0,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    0,
                    [">", ["get", "th"], 360],
                    0,
                    1
                ]
            ]
        ]
    }
});

overlayDefintions.push({
    'id': 'MTallVesselsCircle',
    'type': 'circle',
    'source': 'mtallvessels',
    'source-layer': "mtallvessels",
    paint: {
        'circle-radius': [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            [
                "match",
                ["get", "uv"],
                [1],
                10,
                5
            ],
            3,
            [
                "match",
                ["get", "uv"],
                [1],
                10,
                5
            ]
        ],
        'circle-stroke-width': 1,
        'circle-blur': [
            "match",
            ["get", "uv"],
            [1],
            0,
            0.5
        ],
        'circle-stroke-color':
            [
                "match",
                ["get", "uv"],
                [1],
                '#FFFF00',
                '#000000'
            ],
        'circle-color': ["match",
            ["get", "at"],
            [54], "#7e7e00",
            [71, 70, 72, 73, 74, 75, 76, 77, 78, 79], "#00007e",
            [33], "#7E007E",
            [34], "#7e0000",
            [35], "#FFFF00",
            [30], "#00ff00",
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49], "#7e7e7e",
            [55], "#007eff",
            [56, 57], "#00ff7e",
            [58], "#7e00ff",
            [59], "#7eff00",
            [90, 91, 92, 93, 94, 95, 96, 97, 98, 99], "#007e7e",
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69], "#00ffff",
            [50], "#ff007e",
            [37], "#00003e",
            [53], "#0000ff",
            [36], "#ff00ff",
            [51], "#ff7e7e",
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89], "#ff0000",
            [31], "#ffff7e",
            [32], "#ff2000",
            [52], "#ff7e00",
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29], "#003e00",
            "#dddddd"],
        "circle-opacity":
            [
                "interpolate",
                ["linear"],
                ["zoom"],
                6,
                1,
                8,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    1,
                    [">", ["get", "th"], 360],
                    1,
                    0
                ],
                13,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    1,
                    [">", ["get", "th"], 360],
                    1,
                    0
                ],
                14,
                [
                    "match",
                    ["get", "dv"],
                    [1],
                    0,
                    [
                        "case",
                        ["<", ["get", "sp"], 1],
                        1,
                        [">", ["get", "th"], 360],
                        1,
                        0
                    ]
                ]
            ],
        "circle-stroke-opacity":
            [
                "interpolate",
                ["linear"],
                ["zoom"],
                6,
                1,
                8,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    1,
                    [">", ["get", "th"], 360],
                    1,
                    0
                ],
                13,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    1,
                    [">", ["get", "th"], 360],
                    1,
                    0
                ],
                14,
                [
                    "match",
                    ["get", "dv"],
                    [1],
                    0,
                    [
                        "case",
                        ["<", ["get", "sp"], 1],
                        1,
                        [">", ["get", "th"], 360],
                        1,
                        0
                    ]
                ]
            ]
    }
});

overlayDefintions.push({
    'id': 'MTallVesselsCircle_inject',
    'type': 'circle',
    'source': 'mtallvessels_inject',
    'source-layer': "mtallvessels",
    paint: {
        'circle-radius': [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            [
                "match",
                ["get", "uv"],
                [1],
                10,
                5
            ],
            3,
            [
                "match",
                ["get", "uv"],
                [1],
                10,
                5
            ]
        ],
        'circle-stroke-width': 1,
        'circle-blur': [
            "match",
            ["get", "uv"],
            [1],
            0,
            0.5
        ],
        'circle-stroke-color':
            [
                "match",
                ["get", "uv"],
                [1],
                '#FFFF00',
                '#000000'
            ],
        'circle-color': ["match",
            ["get", "at"],
            [54], "#7e7e00",
            [71, 70, 72, 73, 74, 75, 76, 77, 78, 79], "#00007e",
            [33], "#7E007E",
            [34], "#7e0000",
            [35], "#FFFF00",
            [30], "#00ff00",
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49], "#7e7e7e",
            [55], "#007eff",
            [56, 57], "#00ff7e",
            [58], "#7e00ff",
            [59], "#7eff00",
            [90, 91, 92, 93, 94, 95, 96, 97, 98, 99], "#007e7e",
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69], "#00ffff",
            [50], "#ff007e",
            [37], "#00003e",
            [53], "#0000ff",
            [36], "#ff00ff",
            [51], "#ff7e7e",
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89], "#ff0000",
            [31], "#ffff7e",
            [32], "#ff2000",
            [52], "#ff7e00",
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29], "#003e00",
            "#dddddd"],
        "circle-opacity":
            [
                "interpolate",
                ["linear"],
                ["zoom"],
                6,
                1,
                8,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    1,
                    [">", ["get", "th"], 360],
                    1,
                    0
                ],
                13,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    1,
                    [">", ["get", "th"], 360],
                    1,
                    0
                ],
                14,
                [
                    "match",
                    ["get", "dv"],
                    [1],
                    0,
                    [
                        "case",
                        ["<", ["get", "sp"], 1],
                        1,
                        [">", ["get", "th"], 360],
                        1,
                        0
                    ]
                ]
            ],
        "circle-stroke-opacity":
            [
                "interpolate",
                ["linear"],
                ["zoom"],
                6,
                1,
                8,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    1,
                    [">", ["get", "th"], 360],
                    1,
                    0
                ],
                13,
                [
                    "case",
                    ["<", ["get", "sp"], 1],
                    1,
                    [">", ["get", "th"], 360],
                    1,
                    0
                ],
                14,
                [
                    "match",
                    ["get", "dv"],
                    [1],
                    0,
                    [
                        "case",
                        ["<", ["get", "sp"], 1],
                        1,
                        [">", ["get", "th"], 360],
                        1,
                        0
                    ]
                ]
            ]
    }
});

overlayDefintions.push({
    'id': 'MTallVesselsCircleLabel',
    'type': 'symbol',
    'source': 'mtallvessels',
    'source-layer': "mtallvessels",
    'layout': {
        'icon-image': 'square',
        'icon-text-fit': 'both',
        'icon-text-fit-padding': [5, 10, 5, 10],
        'text-field': [
            "concat",
            ["to-string", ["get", "name"]]
        ],
        'text-variable-anchor': ['bottom-right', 'bottom', 'bottom-left', 'left', 'top-left', 'top', 'top-right', 'right', 'center'],
        'text-radial-offset': 3,
        'text-justify': 'auto',
        'text-size': 10,
        'text-allow-overlap': true,
        'icon-allow-overlap': true,
    },
    paint: {
        'text-color': '#000000',
        'icon-halo-color': "#ffffff",
        'icon-halo-width': 3,
        'icon-color': '#ffffff',
    },
    filter: ["any",
        ['==', 'uv', 1],
        ['==', 'sv', 1]
    ]
});

var incident_style_none = "#FF0000";
var incident_style_S = ["match", ["get", "S"], "Hijacked", "#ff0000", "Kidnapped", "#cc00cc", "Robbed", "#ff8c00", "Boarded", "#ffd700", "Fired-Upon", "#000000", "Approached", "#808080", "Suspicious Sighting", "#0000ff", "Unknown / not clear", "#8B4513", "#8B4513"];
var incident_style_TOD = ["match", ["get", "TOD"], "Day", "#ffff00", "Unknown / not clear", "#8B4513", "Sunrise / set", "#808000", "Night", "#000080", "#8B4513"];
var incident_style_VS = ["match", ["get", "VS"], "Anchored", "#ffff00", "Steaming", "#800080", "Unknown", "#8B4513", "Berthed", "#008080", "Drifting", "#808000", "n/a", "#808080", "#8B4513"];
var incident_style_VT = ["match", ["get", "VT"], "Search and Rescue vessel", "#ff7e7e", "Law Enforcement", "#007eff", "High speed craft (HSC)", "#7e7e7e", "Diving ops", "#7e0000", "Towing", "#ffff7e", "Tug", "#ff7e00", "Wing in ground (WIG)", "#003e00", "Fishing", "#00ff00", "Other Type", "#007e7e", "Local Vessel", "#00ff7e", "Pleasure Craft", "#00003e", "Towing: length exceeds 200m or breadth exceeds 25m", "#ff2000", "Sailing", "#ff00ff", "Dredging or underwater ops", "#7e007e", "Tanker", "#ff0000", "Passenger", "#00ffff", "Not available", "#8B4513", "Cargo", "#00007e", "Military ops", "#FFFF00", "#8B4513"];
var incident_style_W = ["match", ["get", "W"], "RPG(s)", "#000000", "Gun(s)", "#ff0000", "Blade(s)", "#808000", "Other", "#FFFF00", "No Weapons", "#00ff00", "Unknown / not clear", "#8B4513", "#8B4513"];
var incident_style_none = ["match", ["get", "N"], "All Incidents", "#FF0000", "#FF0000"];

overlayDefintions.push({
    'id': 'MTFlyToLayer',
    'type': 'symbol',
    'source': 'MTFlyToSource',
    'layout': {
        'icon-anchor': 'center',
        'icon-image': 'crosshair',
        'icon-size': 0.5
    },
    paint: {
        'icon-halo-blur': 0,
        'icon-halo-color': "#111111",
        'icon-halo-width': 0,
        'icon-color': "#111111",
        "icon-opacity": 1
    }
});

overlayDefintions.push({
    'id': 'MTallIncidentsIcons',
    'type': 'symbol',
    'source': 'MTallIncidents',
    'layout': {
        'icon-anchor': 'bottom',
        'icon-image': 'pirate',
        'icon-size': 1,
        'icon-allow-overlap': true
    },
    paint: {
        'icon-halo-blur': 2,
        'icon-halo-color': incident_style_S,
        'icon-halo-width': 3,
        'icon-color': incident_style_S,
        "icon-opacity": 1
    }
});

overlayDefintions.push({
    'id': 'MTallIncidentsHeatmap',
    'type': 'heatmap',
    'source': 'MTallIncidents',
    "layout": {},
    "paint": {
        "heatmap-radius": 20,
        'heatmap-opacity': 1,
        'heatmap-weight': 1,
        'heatmap-intensity': 1
    }
});

overlayDefintions.push({
    'id': 'MTallVesselsFootprint',
    'type': 'fill',
    'source': 'mtallvesselsfootprint',
    'source-layer': "mtallvesselsfootprint",
    'minzoom': 13,
    paint: {
        'fill-outline-color': "#dddddd",
        'fill-color': ["match",
            ["get", "at"],
            [54], "#7e7e00",
            [71, 70, 72, 73, 74, 75, 76, 77, 78, 79], "#00007e",
            [33], "#7E007E",
            [34], "#7e0000",
            [35], "#FFFF00",
            [30], "#00ff00",
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49], "#7e7e7e",
            [55], "#007eff",
            [56, 57], "#00ff7e",
            [58], "#7e00ff",
            [59], "#7eff00",
            [90, 91, 92, 93, 94, 95, 96, 97, 98, 99], "#007e7e",
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69], "#00ffff",
            [50], "#ff007e",
            [37], "#00003e",
            [53], "#0000ff",
            [36], "#ff00ff",
            [51], "#ff7e7e",
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89], "#ff0000",
            [31], "#ffff7e",
            [32], "#ff2000",
            [52], "#ff7e00",
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29], "#003e00",
            "#dddddd"],
        'fill-opacity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13,
            0,
            14,
            1
        ]
    }
});

overlayDefintions.push({
    'id': 'MTPathLine',
    'type': 'line',
    'source': 'MTPathLine',
    'layout': {
        'line-join': 'round',
        'line-cap': 'round'
    },
    'paint': {
        'line-color': ['get', 'colour'],
        'line-width': 2
    },
    'minzoom': 1, // Adjust the minimum zoom level
    'maxzoom': 20
});

overlayDefintions.push({
    'id': 'MTPathPoint',
    'type': 'symbol',
    'source': 'MTPathPoint',
    'layout': {
        'icon-image': 'vessel',
        'icon-size': 0.75,
        'icon-allow-overlap': true,
        'icon-rotate': ["get", "heading"],
        'icon-pitch-alignment': "map",
        'icon-rotation-alignment': "map",
        'symbol-placement': "point"
    },
    paint: {
        'icon-halo-blur': 0.5,
        'icon-halo-color': "#000000",
        'icon-halo-width': 3,
        'icon-color': ["match",
            ["get", "at"],
            [54], "#7e7e00",
            [71, 70, 72, 73, 74, 75, 76, 77, 78, 79], "#00007e",
            [33], "#7E007E",
            [34], "#7e0000",
            [35], "#FFFF00",
            [30], "#00ff00",
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49], "#7e7e7e",
            [55], "#007eff",
            [56, 57], "#00ff7e",
            [58], "#7e00ff",
            [59], "#7eff00",
            [90, 91, 92, 93, 94, 95, 96, 97, 98, 99], "#007e7e",
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69], "#00ffff",
            [50], "#ff007e",
            [37], "#00003e",
            [53], "#0000ff",
            [36], "#ff00ff",
            [51], "#ff7e7e",
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89], "#ff0000",
            [31], "#ffff7e",
            [32], "#ff2000",
            [52], "#ff7e00",
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29], "#003e00",
            "#dddddd"],
        "icon-opacity": 1
    }
});

var mapStle_at = ["match",
    ["get", "at"],
    [54], "#7e7e00",
    [71, 70, 72, 73, 74, 75, 76, 77, 78, 79], "#00007e",
    [33], "#7E007E",
    [34], "#7e0000",
    [35], "#FFFF00",
    [30], "#00ff00",
    [40, 41, 42, 43, 44, 45, 46, 47, 48, 49], "#7e7e7e",
    [55], "#007eff",
    [56, 57], "#00ff7e",
    [58], "#7e00ff",
    [59], "#7eff00",
    [90, 91, 92, 93, 94, 95, 96, 97, 98, 99], "#007e7e",
    [60, 61, 62, 63, 64, 65, 66, 67, 68, 69], "#00ffff",
    [50], "#ff007e",
    [37], "#00003e",
    [53], "#0000ff",
    [36], "#ff00ff",
    [51], "#ff7e7e",
    [80, 81, 82, 83, 84, 85, 86, 87, 88, 89], "#ff0000",
    [31], "#ffff7e",
    [32], "#ff2000",
    [52], "#ff7e00",
    [20, 21, 22, 23, 24, 25, 26, 27, 28, 29], "#003e00",
    "#dddddd"];

var mapStle_st = ["match",
    ["get", "st"],
    ["Bulk"], "#00007e",
    ["Chem"], "#FFFF00",
    ["Comb"], "#7e7e7e",
    ["Cont"], "#42d4f4",
    ["Crus"], "#FF8C00",
    ["Gen"], "#4363d8",
    ["Live"], "#007eff",
    ["LNG"], "#7E007E",
    ["LPG"], "#7e0000",
    ["Misc"], "#dddddd",
    ["Offs"], "#00ff00",
    ["Pass"], "#00ffff",
    ["PCC"], "#ff007e",
    ["Reef"], "#00003e",
    ["RoRo"], "#ff00ff",
    ["Tank"], "#ff0000",
    ["VP"], "#ff2000",
    "#dddddd"];

var mapStyle_na = ["match",
    ["get", "na"],
    [0], "#00ff00",
    [1], "#00007e",
    [2], "#FFFF00",
    [3], "#42d4f4",
    [4], "#7E007E",
    [5], "#00ffff",
    [6], "#00003e",
    [7], "#ff00ff",
    [8], "#ff2000",
    "#dddddd"];

var mapStyle_lb = ["match",
    ["get", "lb"],
    ["l"], "#00ff00",
    ["b"], "#ff0000",
    "#dddddd"];

var mapStyle_tt = ["match",
    ["get", "tt"],
    ["Cln"], "#00ff00",
    ["Dty"], "#ff0000",
    ["C/D"], "#FFFF00",
    "#dddddd"];

var atTable = [
    { Code: -1, Type: "Not available", Colour: "#dddddd" },
    { Code: 0, Type: "Not available", Colour: "#dddddd" },
    { Code: 1, Type: "Not available", Colour: "#dddddd" },
    { Code: 2, Type: "Not available", Colour: "#dddddd" },
    { Code: 3, Type: "Not available", Colour: "#dddddd" },
    { Code: 4, Type: "Not available", Colour: "#dddddd" },
    { Code: 5, Type: "Not available", Colour: "#dddddd" },
    { Code: 6, Type: "Not available", Colour: "#dddddd" },
    { Code: 7, Type: "Not available", Colour: "#dddddd" },
    { Code: 8, Type: "Not available", Colour: "#dddddd" },
    { Code: 9, Type: "Not available", Colour: "#dddddd" },
    { Code: 10, Type: "Not available", Colour: "#dddddd" },
    { Code: 11, Type: "Not available", Colour: "#dddddd" },
    { Code: 12, Type: "Not available", Colour: "#dddddd" },
    { Code: 13, Type: "Not available", Colour: "#dddddd" },
    { Code: 14, Type: "Not available", Colour: "#dddddd" },
    { Code: 15, Type: "Not available", Colour: "#dddddd" },
    { Code: 16, Type: "Not available", Colour: "#dddddd" },
    { Code: 17, Type: "Not available", Colour: "#dddddd" },
    { Code: 18, Type: "Not available", Colour: "#dddddd" },
    { Code: 19, Type: "Not available", Colour: "#dddddd" },
    { Code: 20, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 21, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 22, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 23, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 24, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 25, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 26, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 27, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 28, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 29, Type: "Wing in ground", Colour: "#003e00" },
    { Code: 30, Type: "Fishing", Colour: "#00ff00" },
    { Code: 31, Type: "Towing", Colour: "#ffff7e" },
    { Code: 32, Type: "Towing: Long", Colour: "#ff2000" },
    { Code: 33, Type: "Dredging or underwater ops", Color: "#7E007E" },
    { Code: 34, Type: "Diving ops", Colour: "#7e0000" },
    { Code: 35, Type: "Military ops", Colour: "#FFFF00" },
    { Code: 36, Type: "Sailing", Colour: "#ff00ff" },
    { Code: 37, Type: "Pleasure Craft", Colour: "#00003e" },
    { Code: 38, Type: "Not available", Colour: "#dddddd" },
    { Code: 39, Type: "Not available", Colour: "#dddddd" },
    { Code: 40, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 41, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 42, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 43, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 44, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 45, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 46, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 47, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 48, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 49, Type: "High speed craft", Colour: "#7e7e7e" },
    { Code: 50, Type: "Pilot Vessel", Colour: "#ff007e" },
    { Code: 51, Type: "Search and Rescue", Colour: "#ff7e7e" },
    { Code: 52, Type: "Tug", Colour: "#ff7e00" },
    { Code: 53, Type: "Port Tender", Colour: "#0000ff" },
    { Code: 54, Type: "Anti-pollution equipment", Colour: "#7e7e00" },
    { Code: 55, Type: "Law Enforcement", Colour: "#007eff" },
    { Code: 56, Type: "Local Vessel", Colour: "#00ff7e" },
    { Code: 57, Type: "Local Vessel", Colour: "#00ff7e" },
    { Code: 58, Type: "Medical Transport", Colour: "#7e00ff" },
    { Code: 59, Type: "Noncombatant ship", Colour: "#7eff00" },
    { Code: 60, Type: "Passenger", Colour: "00ffff" },
    { Code: 61, Type: "Passenger", Colour: "00ffff" },
    { Code: 62, Type: "Passenger", Colour: "00ffff" },
    { Code: 63, Type: "Passenger", Colour: "00ffff" },
    { Code: 64, Type: "Passenger", Colour: "00ffff" },
    { Code: 65, Type: "Passenger", Colour: "00ffff" },
    { Code: 66, Type: "Passenger", Colour: "00ffff" },
    { Code: 67, Type: "Passenger", Colour: "00ffff" },
    { Code: 68, Type: "Passenger", Colour: "00ffff" },
    { Code: 69, Type: "Passenger", Colour: "00ffff" },
    { Code: 70, Type: "Cargo", Color: "#00007e" },
    { Code: 71, Type: "Cargo", Color: "#00007e" },
    { Code: 72, Type: "Cargo", Color: "#00007e" },
    { Code: 73, Type: "Cargo", Color: "#00007e" },
    { Code: 74, Type: "Cargo", Color: "#00007e" },
    { Code: 75, Type: "Cargo", Color: "#00007e" },
    { Code: 76, Type: "Cargo", Color: "#00007e" },
    { Code: 77, Type: "Cargo", Color: "#00007e" },
    { Code: 78, Type: "Cargo", Color: "#00007e" },
    { Code: 79, Type: "Cargo", Color: "#00007e" },
    { Code: 80, Type: "Tanker", Colour: "#ff0000" },
    { Code: 81, Type: "Tanker", Colour: "#ff0000" },
    { Code: 82, Type: "Tanker", Colour: "#ff0000" },
    { Code: 83, Type: "Tanker", Colour: "#ff0000" },
    { Code: 84, Type: "Tanker", Colour: "#ff0000" },
    { Code: 85, Type: "Tanker", Colour: "#ff0000" },
    { Code: 86, Type: "Tanker", Colour: "#ff0000" },
    { Code: 87, Type: "Tanker", Colour: "#ff0000" },
    { Code: 88, Type: "Tanker", Colour: "#ff0000" },
    { Code: 89, Type: "Tanker", Colour: "#ff0000" },
    { Code: 90, Type: "Other Type", Colour: "007e7e" },
    { Code: 91, Type: "Other Type", Colour: "007e7e" },
    { Code: 92, Type: "Other Type", Colour: "007e7e" },
    { Code: 93, Type: "Other Type", Colour: "007e7e" },
    { Code: 94, Type: "Other Type", Colour: "007e7e" },
    { Code: 95, Type: "Other Type", Colour: "007e7e" },
    { Code: 96, Type: "Other Type", Colour: "007e7e" },
    { Code: 97, Type: "Other Type", Colour: "007e7e" },
    { Code: 98, Type: "Other Type", Colour: "007e7e" },
    { Code: 99, Type: "Other Type", Colour: "007e7e" }
];

var atTableMatch = ["match",
    ["get", "at"],
    [54], "Anti-pollution equipment",
    [71, 70, 72, 73, 74, 75, 76, 77, 78, 79], "Cargo",
    [34], "Diving ops",
    [30], "Fishing",
    [40, 41, 42, 43, 44, 45, 46, 47, 48, 49], "High speed craft (HSC)",
    [55], "Law Enforcement",
    [56, 57], "Local Vessel",
    [58], "Medical Transport",
    [59], "Noncombatant ship",
    [90, 91, 92, 93, 94, 95, 96, 97, 98, 99], "Other Type",
    [60, 61, 62, 63, 64, 65, 66, 67, 68, 69], "Passenger",
    [50], "Pilot Vessel",
    [37], "Pleasure Craft",
    [53], "Port Tender",
    [36], "Sailing",
    [51], "Search and Rescue vessel",
    [80, 81, 82, 83, 84, 85, 86, 87, 88, 89], "Tanker",
    [31], "Towing",
    [32], "Towing Long",
    [52], "Tug",
    [20, 21, 22, 23, 24, 25, 26, 27, 28, 29], "Wing in ground (WIG)",
    "Unknown"];


function atGetDataFromCode(code) {
    return atTable.find(({ Code }) => Code === code)
}

var stTable = [
    { Code: "", Type: "", Colour: "#dddddd" },
    { Code: "-1", Type: "", Colour: "#dddddd" },
    { Code: "Bulk", Type: "Bulk Carrier", Colour: "#00007e" },
    { Code: "Chem", Type: "Chemical Tanker", Colour: "#FFFF00" },
    { Code: "Comb", Type: "Combination Carrier", Colour: "#7e7e7e" },
    { Code: "Cont", Type: "Container Ship", Colour: "#42d4f4" },
    { Code: "Crus", Type: "Cruise Ship", Colour: "#FF8C00" },
    { Code: "Gen", Type: "General Dry Cargo", Colour: "#4363d8" },
    { Code: "Live", Type: "Livestock", Colour: "#007eff" },
    { Code: "LNG", Type: "LNG Carrier", Colour: "#7E007E" },
    { Code: "LPG", Type: "LPG Carrier", Colour: "#7e0000" },
    { Code: "Misc", Type: "Miscellaneous", Colour: "#dddddd" },
    { Code: "Offs", Type: "Offshore", Colour: "#00ff00" },
    { Code: "Pass", Type: "Passenger Ship", Colour: "#00ffff" },
    { Code: "PCC", Type: "Pure Car Carrier", Colour: "#ff007e" },
    { Code: "Reef", Type: "Reefer", Colour: "#00003e" },
    { Code: "RoRo", Type: "Roll-on Roll-off", Colour: "#ff00ff" },
    { Code: "Tank", Type: "Tanker", Colour: "#ff0000" },
    { Code: "VP", Type: "Vehicle/Passenger", Colour: "#ff2000" }
];

var stTableMatch = ["match",
    ["get", "st"],
    ["Bulk"], "Bulk Carrier",
    ["Chem"], "Chemical Tanker",
    ["Comb"], "Combination Carrier",
    ["Cont"], "Container Ship",
    ["Crus"], "Cruise Ship",
    ["Gen"], "General Dry Cargo",
    ["Live"], "Livestock",
    ["LNG"], "LNG Carrier",
    ["LPG"], "LPG Carrier",
    ["Misc"], "Miscellaneous",
    ["Offs"], "Offshore",
    ["Pass"], "Passenger Ship",
    ["PCC"], "Pure Car Carrier",
    ["Reef"], "Reefer",
    ["RoRo"], "Roll-on Roll-off",
    ["Tank"], "Tanker",
    ["VP"], "Vehicle/Passenger",
    "Unknown"];

var naTableMatch = ["match",
    ["get", "na"],
    [0], "Under way using engine",
    [1], "At anchor",
    [2], "Not under command",
    [3], "Restricted maneuverability",
    [4], "Constrained by her draught",
    [5], "Moored",
    [6], "Aground",
    [7], "Engaged in fishing",
    [8], "Under way sailing",
    "Unknown"];

var lbTableMatch = ["match",
    ["get", "lb"],
    ["l"], "Laden",
    ["b"], "Ballast",
    "Unknown"];

function stGetDataFromCode(code) {
    return stTable.find(({ Code }) => Code === code)
}

var lbTable = [
    { Code: "l", Type: "", Colour: "#dddddd" },
    { Code: "b", Type: "", Colour: "#dddddd" },
];

function lbGetDataFromCode(code) {
    switch (code) {
        case 'l':
            return "LADEN";
        case 'b':
            return "BALLAST";
        default:
            return "UNKNOWN"
    }
}

function spGetDataFromCode(code) {
    if (isNaN(code)) {
        return null;
    } else {
        return parseFloat(code).toFixed(2) + ' kn';
    }
}